const { useQuery, gql } = require("@apollo/client");

export const FETCH_PRODUCT_ODOO_PRICE = gql`
  query FETCH_PRODUCT_ODOO_PRICE($productId: Int!, $companyId: Int) {
    odooSupplierInfo(productId: $productId, companyId: $companyId) {
      id
      partnerId
      partnerName
      minQty
      currency
      price
      productId
      writeDate
      sequence
      companyId
      companyName
    }
  }
`;

export const useOdooSupplierInfo = (productId, company) => {
  let variables = { productId };
  if (company === "AB") variables.companyId = 1;
  if (company === "LTD") variables.companyId = 3;

  const { loading, error, data } = useQuery(FETCH_PRODUCT_ODOO_PRICE, {
    variables,
  });

  return { loading, error, data };
};
